<template>
  <DashBoardCard title="Concurrent Agents" :loading="loading">
    <template slot="content">
        <DonutChart id="current-agent" :data="concurrentAgents" :colors="['#2DD383', '#D3732D']" :center-text="totalAgent.toString()" center-desc="Total agent"/>
        <div id="legend">
          <div id="legend-unavailable">
            <span>{{totalAgentUnavailable}}</span>
            <span>Unavailable Agent</span>
          </div>
          <div id="legend-available">
            <span>{{totalAgentAvailable}}</span>
            <span>Available Agent</span>
          </div>
        </div>
    </template>
  </DashBoardCard>
</template>

<script>
import DashBoardCard from "@/views/dashboard-realtime/DashBoardCard";
import DonutChart from "components/charts/DonutChart";
import {mapActions, mapGetters, mapState} from "vuex";
export default {
  name: "ConcurrentAgent",
  components: {DonutChart, DashBoardCard},
  computed: {
    ...mapGetters('autoAssign', ['concurrentAgents']),
    ...mapState('autoAssign', ['loading']),
    totalAgent() {
      let totalAgent = 0;
      for (let i= 0; i< this.concurrentAgents.length; i++) {
        totalAgent = totalAgent + this.concurrentAgents[i].value
      }
      return totalAgent
    },
    totalAgentAvailable() {
      if (this.concurrentAgents.length > 0) {
        return this.concurrentAgents[0].value
      }
      return 0;
    },
    totalAgentUnavailable() {
      return this.totalAgent - this.totalAgentAvailable;
    }
  },
  mounted() {
    this.fetchCurrentAutoAssignCfg();
  },
  methods: {
    ...mapActions('autoAssign', ['fetchCurrentAutoAssignCfg'])
  }
}
</script>

<style scoped lang="scss">
#legend {
  display: flex;
  #legend-available{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    span:first-child {
      color: #2DD383;
      font-size: 20px;
      font-weight: bold;
    }
    span:last-child {
      font-size: 14px;
      color: #525463;
    }
  }
  #legend-unavailable{
    display: flex;
    flex-direction: column;
    box-shadow: 1px 0 0 #E2E2ED;
    align-items: center;
    padding: 0 20px;
    span:first-child {
      color: #D3732D;
      font-size: 20px;
      font-weight: bold;
    }
    span:last-child {
      font-size: 14px;
      color: #525463;
    }
  }
}
</style>